export const DIC = {
  HALL_LEVEL: {
    1: '省级大厅',
    2: '市级大厅',
    3: '区县级大厅',
    4: '镇街级大厅',
    5: '社区级大厅'
  },
  HALL_TYPE: {
    governs: '政务大厅',
    major: '专业大厅',
    terminal: '自助终端',
  },
  SEARCH_TYPE: {
    HALL: '大厅',
    ITEM: '事项',
    // OTHER: '其他'
  }
}
